import { render, staticRenderFns } from "./MyMessage.vue?vue&type=template&id=50eb2897&scoped=true&"
import script from "./MyMessage.vue?vue&type=script&lang=js&"
export * from "./MyMessage.vue?vue&type=script&lang=js&"
import style0 from "./MyMessage.vue?vue&type=style&index=0&id=50eb2897&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eb2897",
  null
  
)

export default component.exports